export const getters = {
    currentMatch: state => state.currentMatch,
    sectors: state => state.sectors
};
